//
//
//
//
//
//
//
//
//
export default {
  name: "OilActivityManage",
  data: function data() {
    return {
      isRouterAlive: true
    };
  },
  created: function created() {
    console.log('created OilActivityManage');
  },
  activated: function activated() {
    var _this = this;

    console.log('activated OilActivityManage');
    this.isRouterAlive = false;
    this.$nextTick(function () {
      return _this.isRouterAlive = true;
    });
  }
};